import { render, staticRenderFns } from "./ProvProgramaciones.vue?vue&type=template&id=5ff53ba6"
import script from "./ProvProgramaciones.vue?vue&type=script&lang=js"
export * from "./ProvProgramaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports